import {Pipe, PipeTransform} from '@angular/core';
import {VizixService} from "../../providers/vizix.service";

/**
 * Generated class for the PadRfidPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'padRfid',
})
export class PadRfidPipe implements PipeTransform {
  constructor(private vizixService: VizixService) {
  }

  transform(value: string) {
    try {
      if (this.vizixService.configurationApp.AppParametersConfiguration.AutoPadRFID.value) {
        while (value.length < Number(this.vizixService.configurationApp.AppParametersConfiguration.RFIDLength.value)) {
          value = "0" + value;
        }
      }
      console.log('Padded Rfid: ' + value);
    }
    catch (e)
    {
    }

    return value;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/validate-tag/pad-rfid.ts